export interface IConfig {
  API_URL: string;
}

export const isDevelopment = () => true;

declare global {
  interface Window {
    appConfig: any;
  }
}

// window.appConfig = window.appConfig || {};
// Non-production: driven by the API_URL env var (full URL incl. scheme — set it in .env, e.g.
// http://localhost:3001 for a local ESB). Falls back to the test environment when unset.
const basePath =
  process.env.NODE_ENV !== "production"
    ? process.env.API_URL ?? "https://test.blackfridaynederland.nl"
    : `https://${location.host}`;

export const getConfig = (): IConfig => ({
  API_URL: basePath
});
